import { Link } from "react-router-dom";

// Unified branded button. Renders a router <Link> (to), an <a> (href) or a
// <button>, with primary / ghost variants.
export default function Button({
  to,
  href,
  variant = "primary",
  className = "",
  children,
  ...rest
}) {
  const cls = `btn btn--${variant} ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a className={cls} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}
